import moment from 'moment';

import { getParameterByName } from 'utils/helper';

// A campaign link can preselect the workshop (step 3) and the technician and date (step 4), e.g.
// /maintenance/steps/1?workshop=TALLER_TE01_01&technician=<BusinessPartnerID>&date=2026-11-07
// Each value is applied only if it is still an option for what the customer filled in before.
export const getUrlPreselection = (search = window.location.search) => {
  const date = getParameterByName('date', search);

  return {
    workshop: getParameterByName('workshop', search),
    technician: getParameterByName('technician', search),
    date: moment(date, 'YYYY-MM-DD', true).isValid() ? date : '',
  };
};

// Step 4: the link's technician only if the list answered for the service the customer chose has
// it, and its date only if that day can still be booked.
export const getTechnicianPreselection = (technicians, { technician, date }) => ({
  technician: technician && technicians.find((item) => item.businessPartnerId === technician),
  date: moment(date).isAfter(moment(), 'day') ? date : '',
});
